import { render, staticRenderFns } from "./Wallpaper.vue?vue&type=template&id=ea403666&scoped=true"
import script from "./Wallpaper.vue?vue&type=script&lang=js"
export * from "./Wallpaper.vue?vue&type=script&lang=js"
import style0 from "./Wallpaper.vue?vue&type=style&index=0&id=ea403666&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea403666",
  null
  
)

export default component.exports